import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import { PROCESS_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';



class ProcessList extends Component {
   state = {
        selectedData : [],
        error : false,
        message : null
   }
   
    actionTemplate = (rowData, column) => {
        let processId = rowData.processId;
        return  <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                    <Link to={"/process-form/Edit/"+processId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                    <Link to={"/process-form/View/"+processId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
                </div>;
    }


    statusRender = (rowData, column) => {
        
        let status = <Button type="button" label="InActive" className="p-button-danger p-button-rounded" ></Button>
        if(rowData.isActive === true){
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
                    {status}
               </div>;
    }


    moduleRender = (rowData, column) => {
        
        let moduleNumber = rowData.moduleNum;
        let moduleNo = '';
        if(this.props.moduleLists && this.props.moduleLists.length > 0){
            moduleNo = this.props.moduleLists.filter( mod => {
                return mod.value === moduleNumber
            }).reduce((_,el)=>{
                return el.label;
            },'');
        }
        return moduleNo;
    }


    renderHeader = () => {
        return (
            <div>
                List of Forms
                <div  className="p-datatable-globalfilter-container">
                    <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search" />
                </div>
            </div>
        );
    }


    componentDidMount(){
        this.getAccess = HASACCESS(PROCESS_SUBMENU_ID);
        if(this.props.moduleLists.length === 0){
            this.props.getModuleLists();
        }
        this.props.getProcessMasterLists();
    }
   


    deleteProcessForm  = () => {

        if(this.state.selectedData.length > 0){
            this.setState({loading : true});
            const updatedValue = this.state.selectedData.map( value => {
                return { DeleteID : value.processId};
            });    
            this.props.deleteProcessMasterLists(updatedValue);
            this.setState({selectedData:[]});
        }else{
            this.setState({error:true,message:'Please select atleast one checkbox'})
        }

    }
  
    render() {   

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }



        let dataTableValue = [];
        if(this.props.processMasterLists){
            dataTableValue = this.props.processMasterLists;
        }
        
       
        return (
            <div className="p-grid search">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.state.error && <Messages type="error" message={this.state.message}/>}
                { this.props.success && <Messages type="success" message={this.props.success}/>}
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Process Form List</h1>
               
                        <div className="p-grid">
                         

                            <div className="p-col-12  p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                 <Link to="/process-form"><Button style={{float: 'right'}} label="Add Process Form" className="ml1" icon="pi pi-plus"  /></Link>
                                }
                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                                 <Button onClick={this.deleteProcessForm}  style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                       


                            
                        <DataTable value={dataTableValue} responsive className="p-datatable-customers animated fadeIn" rowHover 
                         selection={this.state.selectedData} globalFilter={this.state.globalFilter}  header={this.renderHeader()} onSelectionChange={e => this.setState({selectedData: e.value,error:false,message:null})}
                         paginator rows={10} emptyMessage="No data found" >
                                
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="processNum" header="Process Number" sortable={true} />
                                <Column field="processDescription" header="Process Desc"  />
                                <Column field="moduleNum" header="Module Number" body={this.moduleRender}   />
                                <Column field="createdBy" header="Created By"/>
                                <Column field="createdDate" header="Created Date"  />
                                <Column field="isActive" header="Status" body={this.statusRender} sortable={true} />
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        processMasterLists : state.master.processMasterLists,
        moduleLists : state.master.keywordValuesList,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success
    }
}


const mapDispatchToProps = dispatch => {
    return{
        getModuleLists : () => dispatch(actions.getKeywordValues('Module')),
        getProcessMasterLists : () => dispatch(actions.getProcessMasterLists()),
        deleteProcessMasterLists : (selectedData) => dispatch(actions.deleteProcessMasterLists(selectedData)),
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(ProcessList);